import { ReactComponent as ArrowLeftIcon } from '@assets/icons/V4/session-details/arrow-left-icon.svg';
import { ReactComponent as ArrowRightIcon } from '@assets/icons/V4/session-details/arrow-right-icon.svg';
import Button from '@components/V4/Button';
import { ReactComponent as ArrowIcon } from '@assets/icons/V4/arrow-icon.svg';
import { useAnalytics } from 'apps/agora/src/contexts/AnalyticsContext';
import { ANALYTICS_EVENT_NAMES } from 'apps/agora/src/utils/constants';
import { useHistory, useParams } from 'react-router-dom';
import { useContext } from 'react';
import { SessionDetailsContext } from '@modules/SessionDetails/context/SessionDetailsContext';
import Tooltip from '@components/V4/Tooltip';
import IconButton from '@components/V4/IconButton';
import { useTranslation } from 'apps/agora/src/TranslationContext';

interface SessionDetailsNavigationArrowsProps {
  nextSession?: string;
  prevSession?: string;
}

const SessionDetailsNavigationArrows = (props: SessionDetailsNavigationArrowsProps) => {
  const { prevSession, nextSession } = props;
  const { studentId } = useParams<{ studentId: string }>();
  const history = useHistory();
  const { trackEvent } = useAnalytics();
  const { isParentView } = useContext(SessionDetailsContext);
  const { t } = useTranslation();

  const nextSessionButtonHandler = () => {
    if (!nextSession) return;

    trackEvent(ANALYTICS_EVENT_NAMES.SESSION_NAVIGATION_ARROW_CLICK);

    if (isParentView) {
      history.push(`/parent-view/${studentId}/sessions/${nextSession}`);
    } else {
      history.push(`/session-details/${nextSession}`);
    }
  };

  const prevSessionButtonHandler = () => {
    if (!prevSession) return;

    trackEvent(ANALYTICS_EVENT_NAMES.SESSION_NAVIGATION_ARROW_CLICK);

    if (isParentView) {
      history.push(`/parent-view/${studentId}/sessions/${prevSession}`);
    } else {
      history.push(`/session-details/${prevSession}`);
    }
  };

  return (
    <div className="flex gap-4">
      {isParentView ? (
        <>
          <Button
            variant='secondary'
            onClick={prevSessionButtonHandler}
            buttonText={t('sessionDetails.navigation.previousSession')}
            disabled={!prevSession}
          />
          <Button
            variant='secondary'
            onClick={nextSessionButtonHandler}
            buttonText={t('sessionDetails.navigation.nextSession')}
            disabled={!nextSession}
          />
        </>
      ) : (
        <>
          <Tooltip text={t('sessionDetails.navigation.previousSession')}>
            <IconButton
              variant="secondary"
              className="flex items-center justify-center w-10 h-10"
              icon={<ArrowIcon className="-rotate-90 w-4 h-4" />}
              onClick={prevSessionButtonHandler}
              isDisabled={!prevSession}
            />
          </Tooltip>

          <Tooltip text={t('sessionDetails.navigation.nextSession')}>
            <IconButton
              variant="secondary"
              className="flex items-center justify-center w-10 h-10"
              icon={<ArrowIcon className="rotate-90 w-4 h-4" />}
              onClick={nextSessionButtonHandler}
              isDisabled={!nextSession}
            />
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default SessionDetailsNavigationArrows;
